import dataReducer from './data/reducer'
import pagesReducer from './pages/reducer'

export default {
  data: dataReducer,
  pages: pagesReducer,
}
